import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AttributeBadge } from '@tassat/symbols';
import React from 'react';

interface BooleanCellRendererProps {
    value: boolean;
}

const muiStyles = makeStyles({ root: { whiteSpace: 'normal' as const }});

const BooleanCellRenderer = (props: BooleanCellRendererProps) => {
    const { value } = props;

    const classes = muiStyles(props);

    return (
        <Grid
            alignItems='center'
            className={classes.root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            <Grid item>
                <AttributeBadge
                    active
                    testId='badge-boolean'
                    value={value ? 'Y' : 'N'}
                />
            </Grid>
        </Grid>
    );
};

export default BooleanCellRenderer;